import { createApiRef } from '@backstage/frontend-plugin-api';
import type { AppsMonitorSummary } from '@internal/plugin-apps-monitor-common';

export interface AppsMonitorApi {
  getSummary(): Promise<AppsMonitorSummary>;
}

export const appsMonitorApiRef = createApiRef<AppsMonitorApi>().with({
  id: 'apps-monitor',
  pluginId: 'apps-monitor',
});
